(function($) {

	function load_products(lan) {
		// console.log(lan);
		// $('.store-output').html(" ");
		$('.store-output').css('opacity', 0.3);
		$('.store-hidden').html(" ");
		let handle = [];
		for (let option of $('.store-wrapper-categories-selector-option > input[type="checkbox"]:checked')) {
			if ($(option).val() != "all") {
				handle.push($(option).val())
			}
		}
		if (handle.length == 0) {
			handle.push("all");
		}
		let sort_by = $('.store-wrapper-content-sort-by-option.checked').attr('value');

		var g_url = (lan == "fr") ? `/collections/${$('.store-wrapper-categories-selector-option:has(input:checked) > input').val()}` : `/${lan}/collections/${$('.store-wrapper-categories-selector-option:has(input:checked) > input').val()}`;
		// console.log(url);
		let ajaxRequests = handle.map(cat => {
			return $.ajax({
				type: 'GET',
				url: g_url,
				data: {
					sort_by: sort_by
				},
				success: function(response) {
					$('.store-hidden').append(response);
				},
				error: function(xhr, status, error) {
					console.error('AJAX request failed:', status, error);
				}
			});
		});

		$.when(...ajaxRequests).done(function() {
			// var sortBy = sort_by;
			var $productGrid = $('.store-hidden');
			var $products = $productGrid.children('.store-output-product');

			var sortedProducts = $products.sort(function(a, b) {
				var aPrice = parseInt($(a).data('price'));
				var bPrice = parseInt($(b).data('price'));
				var aTitle = $(a).data('title').toLowerCase();
				var bTitle = $(b).data('title').toLowerCase();
				var aRating = parseFloat($(a).find('.product-related-wrapper-product-content-rating-value').text().replace(/[()]/g, '').trim()) || 0;
				var bRating = parseFloat($(b).find('.product-related-wrapper-product-content-rating-value').text().replace(/[()]/g, '').trim()) || 0;
				

				return bRating - aRating;


				// if (sortBy === 'price-asc') {
				// 	return aPrice - bPrice;
				// } else if (sortBy === 'price-desc') {
				// 	return bPrice - aPrice;
				// } else if (sortBy === 'title-asc') {
				// 	return aTitle.localeCompare(bTitle);
				// } else if (sortBy === 'title-desc') {
				// 	return bTitle.localeCompare(aTitle);
				// }

			});
			// console.log(sortedProducts);
			$productGrid.empty().append(sortedProducts);

			// Copy the sorted content to .store-output
			$('.store-output').html($productGrid.html());
			$('.store-output').css('opacity', 1);
		});

	}

	$(document).ready(function() {
		const urlParams = new URLSearchParams(window.location.search);

		$('.store-wrapper-categories-selector-option').each(function() {
			let $checkbox = $(this).find('input[type="checkbox"]');
			if (urlParams.has($checkbox.val())) {
				$checkbox.click();
				$('input[value="all"]').prop('checked', false);
			}
		});
		if ($('.store-wrapper-categories-selector-option').length > 0) {
			load_products($('html').attr('lang'));
		}
		$('.store-wrapper-categories-selector-option').click(function(event) {
			event.preventDefault();
			
			$('.store-wrapper-categories-selector-option').find('input[type="checkbox"]').prop('checked', false);
			let $checkbox = $(this).find('input[type="checkbox"]');
			let isChecked = $checkbox.is(':checked');
			let value = $checkbox.val();

			if (value === 'all') {
				if (!isChecked) {
					// Deselect all other checkboxes
					$('.store-wrapper-categories-selector-option input[type="checkbox"]').prop('checked', false);
					// Select the "all" checkbox
					$checkbox.prop('checked', true);
				}
			} else {
				$('.store-wrapper-categories-selector-option input[type="checkbox"]').prop('checked', false);
				// Deselect the "all" checkbox if any other checkbox is clicked
				if (!isChecked) {
					$('.store-wrapper-categories-selector-option input[type="checkbox"][value="all"]').prop('checked', false);
					// Select the clicked checkbox
					$checkbox.prop('checked', true);
				} else {
					// Uncheck the clicked checkbox
					$checkbox.prop('checked', false);
				}
			}

			// Check if no checkboxes are selected, then select "all"
			if ($('.store-wrapper-categories-selector-option input[type="checkbox"]:checked').length === 0) {
				$('.store-wrapper-categories-selector-option input[type="checkbox"][value="all"]').prop('checked', true);
			}
			
			load_products($('html').attr('lang'));
		})
		// $('.store-wrapper-content-sort-by').change(function() {
		// 	load_products();
		// })

		$('.store-wrapper-content-sort-placeholder').click(function() {
			$('.store-wrapper-content-sort-by').slideToggle(300);
		});
		$('.store-wrapper-content-sort-by-option').click(function() {
			$('.store-wrapper-content-sort-by-option').not($(this)).removeClass('checked');
			$(this).addClass('checked');
			$('.store-wrapper-content-sort-placeholder > span').text($(this).text());
			$('.store-wrapper-content-sort-by').slideToggle(300);
			load_products($('html').attr('lang'));
		})
	});

})(jQuery);